// extracted by mini-css-extract-plugin
module.exports = {"root":"snippet-cover_root__mg69U"};